import axios from 'axios';
import store from 'tradera-state/configure-store';
import { setCurrencyIfNotChosen } from 'tradera-state/multi-currency';
import multiCurrencyRenderer from './multi-currency-renderer';
import logger from 'packages/logger';

let _booted = false;

let CancelToken = axios.CancelToken;
let cancel;

const activateMultiCurrency = currency => {
    multiCurrencyRenderer.render();
    store.dispatch(setCurrencyIfNotChosen(currency));
};

const boot = async initData => {
    const multiCurrencyEnabled = !!initData.featureSwitches['multi-currency'];
    if (!multiCurrencyEnabled) {
        return;
    }
    if (_booted) {
        return;
    }

    _booted = true;
    if (window && window.location.search.indexOf('force-currency-dev') > -1) {
        activateMultiCurrency('EUR');
        return;
    }
    if (initData.memberCountry === 'Sverige') {
        return;
    }

    const url = 'https://geo.tradera.com/api/country';

    if (cancel !== undefined) {
        cancel();
    }

    try {
        const response = await axios.get(url, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        });
        if (!response.data || response.data.isoCode === 'SE') {
            return;
        }
        activateMultiCurrency(response.data.currency);
    } catch (error) {
        if (error.message !== 'Cancel') {
            logger(error);
        }
    }
};

export default {
    boot
};
